<template>
  <div>
    <div class="overflow-hidden flex justify-center">
      <div>
        <div class="head m-b-6">
          <h2 style="margin-bottom: 13px">سلام دوباره!</h2>
          <p style="width: 261px">برای ادامه وارد شوید</p>
        </div>
        <div class="items-center m-b-2">
          <div class="mx-auto max-w-screen-xl m-b-126">
            <input
              style="margin: 0"
              type="password"
              class="pass-input"
              v-model="password"
              v-if="!showPass"
              placeholder="گذرواژه"
            />
            <input
              style="margin: 0"
              class="pass-input"
              v-model="password"
              v-if="showPass"
              placeholder="گذرواژه"
            />
            <img
              src="@/assets/icons8-eye-26.png"
              @click="showPassHandler"
              class="pass-eye"
            />
          </div>
        </div>
        <button class="m-btn" @click="checkPassrHandler">ورود</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      showPass: false,
      password: null,
    };
  },
  methods: {
    showPassHandler() {
      console.log(this.showPass);
      this.showPass = !this.showPass;
    },
    hash() {
      var hash = 0,
        i,
        chr;
      if (this.length === 0) return hash;
      for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    checkPassrHandler() {
      console.log(this.password);
    },
  },
};
</script>
